namespace Ir.Components.Workbook.Settings.FilterSettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<number>;
        itemConfig: BaseItemConfig;

        showMappingFilter: KnockoutObservable<boolean>;
        mappingFilterOptions: DevExpress.ui.dxSwitch.Properties;

        filterParams: Ir.Components.Workbook.Settings.Items.FilterSetting.IFilterSettingParams;
        boundFieldParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        displayFieldParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        metricParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;

        boundFieldVisibleOptions: DevExpress.ui.dxSwitch.Properties;
        applyConditionOptions: DevExpress.ui.dxSelectBox.Properties;
        editorTypeOptions: DevExpress.ui.dxSelectBox.Properties;
        conditionOptions: DevExpress.ui.dxSelectBox.Properties;
        conditionTypeOptions: DevExpress.ui.dxSelectBox.Properties;
        titleTextOptions: DevExpress.ui.dxTextBox.Properties;
        scopeActionOptions: DevExpress.ui.dxSelectBox.Properties;
        dynamicParameterOptions: DevExpress.ui.dxSwitch.Properties;
        dynamicParameterNameOptions: DevExpress.ui.dxTextBox.Properties;
        showNullButtonOptions: DevExpress.ui.dxSwitch.Properties;

        titleFontSizeOptions: Ir.Components.Workbook.Settings.Items.FontSizeSetting.IFontSizeSettingParams;
        titleFontStyleOptions: DevExpress.ui.dxButtonGroup.Properties;

        valuesFontSizeOptions: Ir.Components.Workbook.Settings.Items.FontSizeSetting.IFontSizeSettingParams;
        valuesFontStyleOptions: DevExpress.ui.dxButtonGroup.Properties;
    }
    
    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.activeTabOrWidget = params.activeTabOrWidget;
        this.activeTabItem = params.activeTabItem;
        this.itemConfig = this.activeTabOrWidget().itemConfig();
        let config = this.itemConfig as FilterConfig;
        let self = this;
        let widget = this.activeTabOrWidget().widget.getWidget<FilterWidget>() as FilterWidget;

        this.showMappingFilter = ko.observable(config.mappingFilter() > 0 || config.mappingFilter() === null && config.boundField() === null);

        this.mappingFilterOptions = {
            value: this.showMappingFilter as any,
            onValueChanged(e) {
                if (!e.value) {
                    config.mappingFilter(null);
                    widget.saveSettings(function () {
                        widget.tabOrWidget.refresh();
                    });
                }
            }
        };

        this.metricParams = {
            label: "Metric",
            type: MappingPopoverTypeEnum.Metrics,
            id: config.metricField,
            disabled: ko.computed(function () {
                return config.editorType() === FilterWidgetEditorTypeEnum.DateRange || config.editorType() === FilterWidgetEditorTypeEnum.Date;
            }) as any,
            onSelected() {

            },
            onClear() {
                widget.saveSettings(function () {
                    widget.tabOrWidget.refresh();
                });
            }
        };

        this.filterParams = {
            label: "Filter",
            id: config.mappingFilter,
            onFiltering(items: Array<FilterTemplate>) {
                let dashboardWidgets = self.config.activeTab().dashboard.widgets().filter(x => x.widgetType() === WidgetType.Filter);
                let boundFieldsId = dashboardWidgets.map(x => { return (x.widget as FilterWidget).itemConfig.boundField(); });

                let dashboardFilters = self.config.activeTab().filters().filter(x => !x.isMetric()).map(x => x.boundField());
                boundFieldsId.push(...dashboardFilters);

                let newItems = items.filter(x => !boundFieldsId.includes(x.boundField));
                return newItems;
            },
            onSelected(newValue: FilterTemplate) {
                let newField = MappingService.getField(newValue.boundField);
                let oldField = MappingService.getField(config.boundField());

                config.mappingFilter(newValue.id);
                widget.updateBoundField(newField, oldField, false, false);
                config.boundFieldVisible(newValue.showBoundField);
                config.displayField(newValue.displayField);

                widget.saveSettings(function () {
                    widget.tabOrWidget.refresh();
                    widget.publishValues(false, false);
                });
            },
            onClear(oldValue) {
                if (oldValue) {
                    self.showMappingFilter(false);
                    widget.saveSettings(function () {
                        widget.tabOrWidget.refresh();
                    });
                }
            }
        };

        this.boundFieldParams = {
            label: "Bound Field",
            type: MappingPopoverTypeEnum.NonMetricsNonDerivedDates,
            id: config.boundField,
            valueChangeType: FieldMetricSettingsValueChangeTypeEnum.After,
            onFiltering(items: Array<TableNameInputModel>) {
                let dashboardWidgets = self.config.activeTab().dashboard.widgets().filter(x => x.widgetType() === WidgetType.Filter);
                let boundFieldsId = dashboardWidgets.map(x => { return (x.widget as FilterWidget).itemConfig.boundField(); });

                let dashboardFilters = self.config.activeTab().filters().filter(x => !x.isMetric()).map(x => x.boundField());
                boundFieldsId.push(...dashboardFilters);

                let newItems: Array<TableNameInputModel> = [];
                for (let tableNode of items) {
                    let newTableNode = tableNode.clone();
                    let fields = tableNode.visibleFields.filter(function (x) { return !boundFieldsId.includes(x.fieldId); });
                    newTableNode.fields = [];
                    fields.forEach(function (field) {
                        newTableNode.fields.push(field);
                    });

                    if (newTableNode.fields.length !== 0) {
                        newItems.push(newTableNode);
                    }
                };

                return newItems;
            },
            onSelected(newValue, oldValue) {
                widget.updateBoundField(newValue, oldValue);
                widget.publishValues(true, false);
            },
            onClear(oldValue) {
                if (oldValue) {
                    if (config.titleText() === replaceBasicHtmlContent(oldValue.displayName)) {
                        config.titleText(null);
                    }
                    if (!config.titleText() && config.displayField()) {
                        let field = MappingService.getField(config.displayField())
                        config.titleText(replaceBasicHtmlContent(field?.displayName));
                    }

                    if (config.dynamicParameterName() === replaceBasicHtmlContent(oldValue.nodeName)) {
                        config.dynamicParameterName(null);
                    }

                    config.mappingFilter(null);

                    widget.saveSettings(() => {
                        widget.tabOrWidget.refresh();
                    });
                }
            }
        };
        this.displayFieldParams = {
            label: "Display Field",
            type: MappingPopoverTypeEnum.NonMetricsNonDerivedDates,
            valueChangeType: FieldMetricSettingsValueChangeTypeEnum.After,
            id: config.displayField,
            disabled: ko.computed(function () {
                return config.editorType() === FilterWidgetEditorTypeEnum.DateRange || config.editorType() === FilterWidgetEditorTypeEnum.Date
            }),
            onSelected(newValue, oldValue) {
                if (!config.titleText() || (oldValue && config.titleText() === replaceBasicHtmlContent(oldValue.displayName))) {
                    config.titleText(replaceBasicHtmlContent(newValue.displayName));
                }

                widget.saveSettings(function () {
                    widget.tabOrWidget.refresh();
                });
            },
            onClear(oldValue) {
                if (oldValue) {
                    if (config.titleText() === replaceBasicHtmlContent(oldValue.displayName)) {
                        config.titleText(null);
                    }

                    if (!config.titleText() && config.boundField()) {
                        let field = MappingService.getField(config.boundField());
                        config.titleText(replaceBasicHtmlContent(field?.displayName));
                    }

                    config.boundFieldVisible(true);
                    config.mappingFilter(null);

                    widget.saveSettings(function () {
                        widget.tabOrWidget.refresh();
                    });
                }
            }
        };

        this.boundFieldVisibleOptions = {
            value: config.boundFieldVisible as any,
            onValueChanged() {
                widget.saveSettings(function () {
                    widget.tabOrWidget.refresh();
                });
            },
            disabled: ko.computed(function () {
                return config.editorType() === FilterWidgetEditorTypeEnum.DateRange || config.editorType() === FilterWidgetEditorTypeEnum.Date || !config.displayField();
            }) as any
        };

        this.applyConditionOptions = {
            dataSource: new DevExpress.data.ArrayStore({
                data: [
                    { value: FilterWidgetApplyConditionEnum.Manually, text: "Manually" },
                    { value: FilterWidgetApplyConditionEnum.Automatic, text: "Automatic" }
                ],
                key: "value",
            }),
            displayExpr: "text",
            valueExpr: "value",
            width: 110,
            value: config.applyCondition
        };

        this.editorTypeOptions = {
            dataSource: ko.computed(function () {
                let dataSource = [];

                if (config.editorType() === FilterWidgetEditorTypeEnum.DateRange || config.editorType() === FilterWidgetEditorTypeEnum.Date) {
                    dataSource.push({ value: FilterWidgetEditorTypeEnum.DateRange, text: "Date Range" });
                    dataSource.push({ value: FilterWidgetEditorTypeEnum.Date, text: "Date" });
                }
                else {
                    dataSource.push({ value: FilterWidgetEditorTypeEnum.DropDown, text: "Drop Down" });
                    dataSource.push({ value: FilterWidgetEditorTypeEnum.List, text: "List" });
                }

                return dataSource;
            }) as any,
            displayExpr: "text",
            valueExpr: "value",
            width: 130,
            value: config.editorType,
            onValueChanged: function (e) {
                if (e.previousValue === FilterWidgetEditorTypeEnum.DateRange && config.editorType() === FilterWidgetEditorTypeEnum.Date ||
                    e.previousValue === FilterWidgetEditorTypeEnum.Date && config.editorType() === FilterWidgetEditorTypeEnum.DateRange) {
                    widget.publishValues(true, false, false);
                }
            },
        };

        this.conditionOptions = {
            dataSource: ko.computed(function () {
                let dataSource = [];

                if (config.editorType() === FilterWidgetEditorTypeEnum.DateRange) {
                    dataSource.push({ value: FilterWidgetConditionEnum.Between, text: "Between" });
                }
                else if (config.editorType() === FilterWidgetEditorTypeEnum.Date) {
                    dataSource.push({ value: FilterWidgetConditionEnum.SingleSelection, text: "Single Selection" });
                }
                else {
                    dataSource.push({ value: FilterWidgetConditionEnum.MultipleSelection, text: "Multiple Selection" });
                    dataSource.push({ value: FilterWidgetConditionEnum.SingleSelection, text: "Single Selection" });
                }

                return dataSource;
            }) as any,
            displayExpr: "text",
            valueExpr: "value",
            width: 130,
            value: config.condition,
            disabled: ko.computed(function () {
                return config.editorType() === FilterWidgetEditorTypeEnum.DateRange || config.editorType() === FilterWidgetEditorTypeEnum.Date;
            }) as any
        };

        this.conditionTypeOptions = {
            dataSource: ko.computed(function () {
                let dataSource = [];

                if (config.condition() === FilterWidgetConditionEnum.Between) {
                    dataSource.push({ value: FilterConditionTypeEnum.Between, text: "Between" });
                }
                else if (config.condition() === FilterWidgetConditionEnum.MultipleSelection) {
                    dataSource.push({ value: FilterConditionTypeEnum.In, text: "In" });
                    dataSource.push({ value: FilterConditionTypeEnum.NotIn, text: "Not In" });
                }
                else if (config.condition() === FilterWidgetConditionEnum.SingleSelection) {
                    dataSource.push({ value: FilterConditionTypeEnum.Equals, text: "Equals" });
                    dataSource.push({ value: FilterConditionTypeEnum.Different, text: "Different" });
                }

                return dataSource;
            }) as any,
            displayExpr: "text",
            valueExpr: "value",
            width: 120,
            value: config.conditionType,
            disabled: ko.computed(function () {
                return config.editorType() === FilterWidgetEditorTypeEnum.DateRange;
            }) as any
        };

        this.titleTextOptions = {
            value: config.titleText as any,
            width: 170
        };

        this.scopeActionOptions = {
            dataSource: new DevExpress.data.ArrayStore({
                data: [
                    { value: ScopeActionEnum.Default, text: "Default" },
                    { value: ScopeActionEnum.Combine, text: "Combine" },
                    { value: ScopeActionEnum.Overwrite, text: "Overwrite" }
                ],
                key: "value",
            }),
            displayExpr: "text",
            valueExpr: "value",
            width: 110,
            value: config.scopeAction
        };

        this.dynamicParameterOptions = {
            value: config.dynamicParameter as any
        };

        this.dynamicParameterNameOptions = {
            value: config.dynamicParameterName as any,
            width: 140,
            disabled: ko.computed(function () { return !config.dynamicParameter() }) as any
        };

        this.titleFontSizeOptions = {
            value: config.titleTextConfig.fontSize
        };

        this.titleFontStyleOptions = {
            items: [
                {
                    icon: 'bold',
                    style: 'Bold',
                    hint: 'Bold'
                },
                {
                    icon: 'italic',
                    style: 'Italic',
                    hint: 'Italic'
                }
            ] as any,
            keyExpr: 'style',
            stylingMode: 'outlined',
            selectionMode: 'multiple',
            selectedItemKeys: ko.computed(function () {
                return config.titleTextConfig.fontBold() && config.titleTextConfig.fontItalic() ? ['Bold', 'Italic'] :
                    config.titleTextConfig.fontBold() ? ['Bold'] : config.titleTextConfig.fontItalic() ? ['Italic'] : []
            }) as any,
            onItemClick: function (e) {
                if (e.itemData.style === 'Bold') {
                    config.titleTextConfig.fontBold(!config.titleTextConfig.fontBold());
                }
                else if (e.itemData.style === 'Italic') {
                    config.titleTextConfig.fontItalic(!config.titleTextConfig.fontItalic());
                }
            }
        };

        this.valuesFontSizeOptions = {
            value: config.valuesTextConfig.fontSize
        };

        this.valuesFontStyleOptions = {
            items: [
                {
                    icon: 'bold',
                    style: 'Bold',
                    hint: 'Bold'
                },
                {
                    icon: 'italic',
                    style: 'Italic',
                    hint: 'Italic'
                }
            ] as any,
            keyExpr: 'style',
            stylingMode: 'outlined',
            selectionMode: 'multiple',
            selectedItemKeys: ko.computed(function () {
                return config.valuesTextConfig.fontBold() && config.valuesTextConfig.fontItalic() ? ['Bold', 'Italic'] :
                    config.valuesTextConfig.fontBold() ? ['Bold'] : config.valuesTextConfig.fontItalic() ? ['Italic'] : []
            }) as any,
            onItemClick: function (e) {
                if (e.itemData.style === 'Bold') {
                    config.valuesTextConfig.fontBold(!config.valuesTextConfig.fontBold());
                }
                else if (e.itemData.style === 'Italic') {
                    config.valuesTextConfig.fontItalic(!config.valuesTextConfig.fontItalic());
                }
            }
        };

        this.showNullButtonOptions = {
            value: config.showNullButton as any
        };
    }
}